import { jsxs as o, Fragment as k, jsx as n } from "react/jsx-runtime";
import { useBreakpoint as T, GenericLink as b, NextgenImage as $, LoaderType as w, FAIcon as L, Theme as x, IconStyle as S } from "@nextgen-web-framework/all";
import { ConsoleLogger as I } from "@nextgen-web-framework/core";
import { s as t } from "../../ContentCard.module-2ab88d65.mjs";
import { Contents as h, ResourceType as u, Icons as f } from "./types/propsTypes.js";
const g = () => /* @__PURE__ */ n("div", { className: t["vertical-line"] }), C = () => /* @__PURE__ */ n("div", { className: t.dot }), m = (e, i) => /* @__PURE__ */ n("div", { className: t["footer-line"], children: i.filter((c) => !!c).map((c, l) => /* @__PURE__ */ o(k, { children: [
  l > 0 && e,
  " ",
  c && D(c)
] })) }), D = (e) => /* @__PURE__ */ n("div", { className: t.value, children: e }), F = ({
  type: e,
  time: i,
  date: c,
  firstAccountTypeDate: l,
  firstAccountTypeTitle: N,
  secondAccountTypeDate: v,
  secondAccountTypeTitle: d,
  size: s
}) => {
  let r = /* @__PURE__ */ n(k, {});
  switch (e) {
    case h.article:
      r = m(g(), [i, c]);
      break;
    case h.promotion:
      r = /* @__PURE__ */ o(k, { children: [
        m(C(), [N, l]),
        m(C(), [d, v]),
        " "
      ] });
      break;
    case h.resource:
      r = m(g(), [s, i, c]);
      break;
  }
  return r;
}, O = (e) => {
  var r;
  const i = T(), c = (r = e == null ? void 0 : e.imageList) == null ? void 0 : r.find((a) => {
    var y;
    return (y = a == null ? void 0 : a.viewport) == null ? void 0 : y.includes(i);
  }), l = `card-bg-color-${e.backgroundColor || "white"}`, N = `card-color-${e.color || "black"}`, v = () => {
    let a = "";
    switch (e.resourceType) {
      case u.image:
        a = f.Image;
        break;
      case u.video:
        a = f.Video;
        break;
      case u.pdf:
        a = f.PDF;
        break;
    }
    return a;
  }, d = () => {
    I.info(`${e.type} view`);
  }, s = v();
  return /* @__PURE__ */ n(b, { href: e.url ?? "", className: t["content-card-link"], children: /* @__PURE__ */ o(
    "div",
    {
      className: `${t["content-card-container"]}`,
      "data-testid": `content-${e.type}-card-container-testid`,
      children: [
        /* @__PURE__ */ o("div", { className: t.banner, children: [
          (c == null ? void 0 : c.url) && /* @__PURE__ */ n(
            $,
            {
              src: c.url,
              alt: (c == null ? void 0 : c.altText) ?? "",
              className: t["content-card-image"],
              loaderType: w.CONTENTSTACK
            }
          ),
          s && e.type == h.resource && /* @__PURE__ */ n(
            "div",
            {
              className: t["icon-container"],
              "data-testid": "content-type-icon-testid",
              "data-pod-name": "commerce",
              role: "presentation",
              onClick: d,
              onKeyDown: d,
              children: /* @__PURE__ */ n(L, { iconName: s, theme: x.WHITE, iconStyle: S.SOLID })
            }
          )
        ] }),
        /* @__PURE__ */ o("div", { className: `${t.content} ${t[l]} ${t[N]}`, children: [
          /* @__PURE__ */ o("div", { className: t.header, children: [
            /* @__PURE__ */ n("div", { className: t.tag, children: e.tag }),
            e.title && /* @__PURE__ */ n("div", { className: t.title, title: e.title, children: e.title })
          ] }),
          e.description && /* @__PURE__ */ n("div", { className: t.description, children: e.description }),
          /* @__PURE__ */ n("div", { className: t.footer, children: F(e) })
        ] })
      ]
    }
  ) });
};
export {
  h as Contents,
  F as RenderFooter,
  u as ResourceType,
  O as default
};
//# sourceMappingURL=ContentCard.js.map
